import {Component} from '@angular/core';
import {AConcreteResource} from '../../../../AConcreteResource';
import {CustomerModel} from '../../../../../models/resources/customer.model';
import {Router} from '@angular/router';
import {CustomerService} from '../../../../../services/resources/customer.service';
import {MdbButtonComponent} from '../../../../utils/mdb-button/mdb-button.component';
import {MdbModalService} from 'mdb-angular-ui-kit/modal';
import {NewCustomerModalComponent} from '../../new-customer-modal/new-customer-modal.component';
import {CustomNotificationService} from '../../../../../services/utils/custom-notification.service';
import {MdbTableModule} from 'mdb-angular-ui-kit/table';
import {TranslateModule} from '@ngx-translate/core';
import {TableComponent} from '../../../../utils/table/table.component';
import {TableColumnModel} from '../../../../../models/table-column.model';
import {castContactTypeEnum, ContactType} from '../../../../../enums/contact-type';

@Component({
  selector: 'app-customer-contacts',
  imports: [
    MdbButtonComponent,
    MdbTableModule,
    TranslateModule,
    TableComponent,
  ],
  templateUrl: './customer-contacts.component.html',
  styleUrl: './customer-contacts.component.scss',
})
export class CustomerContactsComponent extends AConcreteResource<CustomerModel> {
  childrenColumns: TableColumnModel[] = [
    {
      name: 'CUSTOMERS.COMPANY',
      selector: [{ selector: 'company' }],
    },
    {
      name: 'CUSTOMERS.CONTACT_TYPE',
      selector: [{ selector: 'type' }],
      enum: ContactType,
      enumCastFunction: castContactTypeEnum,
    },
    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          objectBaseLink: '/customers',
          isObjectLink: true,
        },
      ],
    },
  ];

  constructor(
    router: Router,
    public customerService: CustomerService,
    private modalService: MdbModalService,
    private notificationService: CustomNotificationService
  ) {
    super(router, customerService);
  }

  openAddContactModal() {
    const customer = this.model();
    if (!customer?.id) return;
    const modalRef = this.modalService.open(NewCustomerModalComponent, {
      modalClass: 'modal-xl',
      ignoreBackdropClick: true,
      data: {
        parentId: customer.id,
        parentCustomer: customer,
      },
    });
    modalRef.onClose.subscribe((created: CustomerModel | undefined) => {
      if (!created) return;
      this.notificationService.success('CUSTOMERS.SUCCESSFULLY_CREATED');
      // this.customerService.getOne(customer.id).subscribe();
    });
  }
}
